import { Pipe, PipeTransform } from '@angular/core';
import { CategoryInfo } from 'services/application/application.service';

@Pipe({
    name: 'category',
})
export class CategoryPipe implements PipeTransform {
    transform(value: number, Categories: CategoryInfo[]) {
        if (value == null) {
            return 'Not Assigned';
        }

        const entry = (Categories || []).find(c => c.CategoryID === value);

        return (entry && entry.CategoryDescription) || '' + value;
    }
}
